import React, { type ReactNode } from "react";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle } from "ui/text";
import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { MegaphoneIcon, PeopleIcon } from "ui/icons";

export function CustomAgents() {
  return (
    <Section center my={0} py={sectionSpacingY}>
      <Text as="h2" fontSize={{ base: "24px", md: "40px" }} fontWeight="bold" lineHeight={{ base: 1.3, md: 1.2 }}>
        Powerful agents, zero effort
      </Text>

      <SimpleGrid
        mt={{ base: "biggest", md: "huge" }}
        columns={{ base: 1, md: 2 }}
        justifyContent="space-between"
        columnGap="biggest"
        rowGap={{ base: "biggest", md: "huge" }}
      >
        <AgentItem
          icon={<MegaphoneIcon boxSize="icon.xl" />}
          title="Custom agents for your business"
          description="Our platform enables the creation of Custom Agents for your unique use cases, like generating campaigns based on social trends or crafting targeted offers for under-sold products."
        />
        <AgentItem
          icon={<PeopleIcon boxSize="icon.xl" />}
          title="Experts ready to build whatever you need"
          description="Our forward-deployed team works with your leaders to identify and implement high-value AI use cases. They host onsite workshops and trainings for your teams to drive lasting impact."
        />
      </SimpleGrid>
    </Section>
  );
}

function AgentItem({ icon, title, description }: { icon: ReactNode; title: string; description: string }) {
  const bgColor = "radial-gradient(55.42% 55% at 50.25% 55%, #F7FCFF 0%, #D4EEFF 100%)";

  return (
    <Box>
      <Flex
        align="center"
        justify="center"
        boxSize="biggest"
        borderRadius="20px"
        border="3px solid white"
        color="new.blue.900"
        bg={bgColor}
        boxShadow="md"
      >
        {icon}
      </Flex>

      <TextTitle size="xs" titleAs="h3" title={title} description={description} mt="small" maxW="480px" />
    </Box>
  );
}
